
import React, { useCallback, useEffect, useState } from 'react'
import Default from '../CustomFields/Default'
import './FormPlugin.scss'
import useStateRef from 'react-usestateref'

const FormField = (props) => {
  const [fieldShowOrHide, setFieldShowOrHide, fieldShowOrHideRef] = useStateRef(false)

  const labelMerger = (label) => {
    var mergedLabel = "";
    if (label.length != 0) {
      var splitedLabel = label.split(" ");
      if (splitedLabel) {
        splitedLabel.map((oneLabel) => {
          if (splitedLabel.indexOf(oneLabel) != 0) {
            // console.log("oneLabel",oneLabel);
            if (oneLabel) {
              let firstLetterUpperCase = oneLabel[0].toUpperCase();
              let labelSubStr = oneLabel.substr(1, oneLabel.length - 1);
              oneLabel = firstLetterUpperCase + labelSubStr;
            }
          }
          mergedLabel += oneLabel;
        })
      }
    }
    return mergedLabel;
  }

  const textArea = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    //console.log("label--------", props.attributes.event, eventLogic)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
        //console.log("label--------show", fieldShowOrHideRef.current)
      }
      if (eventLogic["hide"]) {
        //console.log("label--------hjide", fieldShowOrHideRef.current)
        setFieldShowOrHide(false)
      }
    }
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}{props.attributes.mandatoryField === "true" ? "*" : ""}</label>
          </div>
          <div className={props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <textarea
              // name={(props.attributes.label).replace(" ", "")} 
              name={labelMerger(props.attributes.label)}
              className="form-control form-text-area" id={(props.attributes.label).replace(" ", "")} rows="3"></textarea>
            {/* <span id={`${(props.attributes.label).replace(" ", "")}_error`}></span> */}
            <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }
  const text = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    console.log("label--------", props)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
        //console.log("label--------show", fieldShowOrHideRef.current)
      }
      if (eventLogic["hide"]) {
        //console.log("label--------hjide", fieldShowOrHideRef.current)
        setFieldShowOrHide(false)
      }
    }
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}{props.attributes.mandatoryField === "true" ? "*" : ""}</label>
          </div>
          <div className={props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <input type={props.type} className="form-control form-text-box"
              // name={(props.attributes.label).replace(" ", "")} 
              name={labelMerger(props.attributes.label)}
              id="" placeholder={`Your ${props.attributes.label}`} />
            {/* <span id={`${(props.attributes.label).replace(" ", "")}_error`}></span> */}
            <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }

  const radioButton = (props) => {
    const groupOfRadioButtonValue = JSON.parse(props.attributes.groupOfRadioButton)
    const [radioButtonValue, setRadioButtonValue] = useState(false)
    const handleChange = (event) => {
      setRadioButtonValue(event.target.checked)
    }
    // console.log("checkkkk---radioButton",props,props.attributes.groupOfRadioButton)
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}</label>
          </div>
          <div className={`${props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}`}>
            {groupOfRadioButtonValue.map((item, index) => (<>
              <input className="form-check-input" type="radio"
                name={labelMerger(props.attributes.label)}
                onClick={handleChange}
                id={labelMerger(item.inputName)}
                value={radioButtonValue ? item.inputValue ? item.inputValue : true : false} />
              <label style={{ marginLeft: '5px', marginRight: '20px' }} for={labelMerger(item.inputName)}>
                {item.inputName}
              </label>
            </>
            ))}
              {radioButtonValue ? '' : <input type='hidden' name={labelMerger(props.attributes.label)} value="" /> }
              <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }

  const checkBox =(props) => {
  
    const groupOfcheckboxValue = JSON.parse(props.attributes.groupOfCheckBox)

    const [checkboxInfo, setCheckboxInfo] = useState({
      checkedValues: [],
      response: [],
    });
    const [checkBoxValue, setCheckBoxValue, checkBoxValueRef] = useStateRef(false)

    const handleChange = (event) => {
      setCheckBoxValue(true)
      const { value, checked } = event.target;
      const { checkedValues } = checkboxInfo;

      if (checked) {
        setCheckboxInfo({
          checkedValues: [...checkedValues, value],
            response: [...checkedValues, value],
        });
    }
    else {
      setCheckboxInfo({
            checkedValues: checkedValues.filter(
                (event) => event !== value
            ),
            response: checkedValues.filter(
                (event) => event !== value
            ),
        });
    }
    }
    return (
      <>
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
      <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label} {props.attributes.mandatoryField === "true" ? "*" : ""}</label>
        </div>
        <div className={`${props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}`}>
          <div className='d-flex'>
          {groupOfcheckboxValue.map((item, index) => (<>
            <div class="form-check">
              <input
                type='checkbox'
                onClick={handleChange}
                name={labelMerger(props.attributes.label)}
                color="primary"
                className="form-check-input"
                id={labelMerger(item.inputName)}
                value={item?.inputValue}
               />
              <label className="form-check-label" style={{ marginRight: '20px' }} for={labelMerger(item.inputName)}>
                {item.inputName}</label>
            </div>
          </>
          ))}
          </div>
            <input type='hidden' name={labelMerger(props.attributes.label)} value={checkBoxValueRef.current ? checkboxInfo.response : ''} /> 
           { props.attributes.reset ? checkboxInfo.response.length !== 0 ? "": <p className='form-error-msg'>{labelMerger(props.attributes.label)} should not be empty</p>: ""}
        </div>
      </div>
      {/* <span id={`${labelMerger(props.attributes.label)}_error`}></span> */}
      </div>
      </>
    )
          }

  const email = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    //console.log("label--------", props.attributes.event, eventLogic)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
        //console.log("label--------show", fieldShowOrHideRef.current)
      }
      if (eventLogic["hide"]) {
        //console.log("label--------hjide", fieldShowOrHideRef.current)
        setFieldShowOrHide(false)
      }
    }
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}{props.attributes.mandatoryField === "true" ? "*" : ""}</label>
          </div>
          <div className={props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <input type={formObj} className="form-control form-text-box" pattern='[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$'
              name={labelMerger(props.attributes.label)}
              id={labelMerger(props.attributes.label)}
              aria-describedby="" placeholder={`Enter ${props.attributes.label}`} />
            {/* <span id={`${(props.attributes.label).replace(" ", "")}_error`}></span> */}
            <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }
  const password = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    //console.log("label--------", props.attributes.event, eventLogic)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
        //console.log("label--------show", fieldShowOrHideRef.current)
      }
      if (eventLogic["hide"]) {
        //console.log("label--------hjide", fieldShowOrHideRef.current)
        setFieldShowOrHide(false)
      }
    }
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}{props.attributes.mandatoryField === "true" ? "*" : ""}</label>
          </div>
          <div className={props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <input type={"password"}
              // name={(props.attributes.label).replace(" ", "")} 
              name={labelMerger(props.attributes.label)}
              className="form-control form-text-box" placeholder="Enter Password" />
            {/* <span id={`${(props.attributes.label).replace(" ", "")}_error`}></span> */}
            <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }
  const handleDropDownValChange = (event) => {
    console.log("eventttttttttt------", props, event.target.value, event.target.name, event)
    var value = event.target.value
    var name = event.target.name
    props.handleShowFields(name, value)
    props.handleHideFields(name, value)

  }
  const dropdown = (props) => {
    const optionsValue = JSON.parse(props.attributes.optionsValue)
    // console.log("checkkkk---optionsValue-------",optionsValue, props)
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}{props.attributes.mandatoryField === "true" ? "*" : ""}</label>
          </div>
          <div className={props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <select
              className='form-select form-select-sm form-text-box'
              name={labelMerger(props.attributes.label)}
              onChange={handleDropDownValChange}
              aria-label="Default select example">
              <option value="">Choose from Below</option>
              {optionsValue.map((item, index) => (
                // group.map((item, subIndex) => (
                <option value={item.inputValue}>{item.inputName}</option>
                // ))
              ))}
            </select>
            <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }
  const richTextEditor = (props) => {
    const eventLogic = props.attributes.event  && props.attributes.event !== "" && JSON.parse(props.attributes.event)
    //console.log("label--------", props.attributes.event, eventLogic)
    if (eventLogic !== undefined) {
      if (eventLogic["show"]) {
        setFieldShowOrHide(true)
        //console.log("label--------show", fieldShowOrHideRef.current)
      }
      if (eventLogic["hide"]) {
        //console.log("label--------hjide", fieldShowOrHideRef.current)
        setFieldShowOrHide(false)
      }
    }
    return (
      <div id={labelMerger(props.attributes.label)}  style={{ display: fieldShowOrHideRef.current ? "none" : "block" }}>
        <div className="mt-2 row">
          {/* <div className={props.attributes.formLabelWidth ? props.attributes.formLabelWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            <label>{props.attributes.label}{props.attributes.mandatoryField === "true" ? "*" : ""}</label>
          </div> */}
          <div className={props.attributes.formLabelTypeWidth ? props.attributes.formLabelTypeWidth  : 'col-md-6 col-sm-12 col-lg-6 col-12'}>
            {/* <p>{`${props.attributes.labelValue}`}</p> */}
            <span dangerouslySetInnerHTML={{ __html: props.attributes.labelValue }}></span>
            <span id={`${labelMerger(props.attributes.label)}_error`}></span>
          </div>
        </div>
      </div>
    )
  }


  const components = {
    textArea: textArea,
    text: text,
    checkBox: checkBox,
    radioButton: radioButton,
    email: email,
    password: password,
    dropdown: dropdown,
    label: richTextEditor,
    richTextEditor: richTextEditor,
    Default: Default,
  }

  var formObj = components[props.type];
  const RenderType = formObj ? formObj : components['Default'];
  return (
    <RenderType attributes={props} />
  )

}

export default FormField

